/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReloadAccountBalanceRequest } from '../../models/reload-account-balance-request';
import { ReloadAccountBalanceResult } from '../../models/reload-account-balance-result';

export interface PostReloadAccountBalance$Params {
  body?: ReloadAccountBalanceRequest;
}

export function postReloadAccountBalance(
  http: HttpClient,
  rootUrl: string,
  params?: PostReloadAccountBalance$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReloadAccountBalanceResult>> {
  const rb = new RequestBuilder(rootUrl, postReloadAccountBalance.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReloadAccountBalanceResult>;
    }),
  );
}

postReloadAccountBalance.PATH = '/Payments/reload-account-balance';
